(function Index($, Adzuki)
{
	"use strict";

	$(document).ready(function onReady()
	{
		Adzuki.onload(['Tasks/index'], function onload()
		{
			_loadTabs();

			$('body').on('ajax-pagination.loaded', function onAjaxLoaded() {
				$('.task-details').off().on('click', _openTaskDetails);
				$('.complete-task').off().on('click', _completeTask);
				$('.pin-task').off().on('click', _pinTask);

				_initSortingOnAllTabs();
			});

			$('#tasks_filter_criteria .remove').click(function removeCriteriaItem(e) {
				_removeFilterCriteria($(this));
			});

			// opening task on page load (used for CP Central notifications and reminder emails)
			if ($('#open-task').length > 0) {
				$('#open-task a').off().on('click', _openTaskDetails);
				$('#open-task a').trigger('click');
			}
		});
	});

	function _completeTask(e)
	{
		var $check_elem = $(this);

		e.preventDefault();

		Adzuki.TaskManager.completeTask($check_elem, function completeTaskCb(active_tab, page_num, order_by, sort_order) {
			_updateTabNumbers();
			_loadTabs(active_tab, page_num, order_by, sort_order);
		});
	}

	function _initSortingOnAllTabs()
	{
		var $filtered_tasks  = $('#filtered-tasks .table-header-sort');
		var $pinned_tasks    = $('#pinned-tasks .table-header-sort');
		var $past_due_tasks  = $('#past-due-tasks .table-header-sort');
		var $today_tasks     = $('#today-tasks .table-header-sort');
		var $upcoming_tasks  = $('#upcoming-tasks .table-header-sort');
		var $completed_tasks = $('#completed-tasks .table-header-sort');

		Adzuki.TaskManager.sortTable($filtered_tasks, function callback(active_tab, page_num, order_by, sort_order)
		{
			_loadTabs(active_tab, page_num, order_by, sort_order);
		});

		Adzuki.TaskManager.sortTable($pinned_tasks, function callback(active_tab, page_num, order_by, sort_order)
		{
			_loadTabs(active_tab, page_num, order_by, sort_order);
		});

		Adzuki.TaskManager.sortTable($past_due_tasks, function callback(active_tab, page_num, order_by, sort_order)
		{
			_loadTabs(active_tab, page_num, order_by, sort_order);
		});

		Adzuki.TaskManager.sortTable($today_tasks, function callback(active_tab, page_num, order_by, sort_order)
		{
			_loadTabs(active_tab, page_num, order_by, sort_order);
		});

		Adzuki.TaskManager.sortTable($upcoming_tasks, function callback(active_tab, page_num, order_by, sort_order)
		{
			_loadTabs(active_tab, page_num, order_by, sort_order);
		});

		Adzuki.TaskManager.sortTable($completed_tasks, function callback(active_tab, page_num, order_by, sort_order)
		{
			_loadTabs(active_tab, page_num, order_by, sort_order);
		});
	}

	function _loadTabs(active_tab, page_num, order_by, sort_order)
	{
		var filtered_page_num  = 1;
		var pinned_page_num    = 1;
		var past_due_page_num  = 1;
		var today_page_num     = 1;
		var upcoming_page_num  = 1;
		var completed_page_num = 1;

		var filtered_order_by  = 'due_date';
		var pinned_order_by    = 'due_date';
		var past_due_order_by  = 'due_date';
		var today_order_by     = 'due_date';
		var upcoming_order_by  = 'due_date';
		var completed_order_by = 'due_date';

		var filtered_sort_order  = 'asc';
		var pinned_sort_order    = 'asc';
		var past_due_sort_order  = 'asc';
		var today_sort_order     = 'asc';
		var upcoming_sort_order  = 'asc';
		var completed_sort_order = 'asc';

		var filtered_url  = '';
		var pinned_url    = '';
		var past_due_url  = '';
		var today_url     = '';
		var upcoming_url  = '';
		var completed_url = '';

		if (active_tab && page_num) {
			switch (active_tab) {
				case 'filtered-tasks':
					filtered_page_num = page_num;
					if (order_by && sort_order) {
						filtered_order_by   = order_by;
						filtered_sort_order = sort_order;
					}
				break;
				case 'upcoming-tasks':
					upcoming_page_num = page_num;
					if (order_by && sort_order) {
						upcoming_order_by   = order_by;
						upcoming_sort_order = sort_order;
					}
				break;
				case 'completed-tasks':
					completed_page_num = page_num;
					if (order_by && sort_order) {
						completed_order_by   = order_by;
						completed_sort_order = sort_order;
					}
				break;
				case 'past-due-tasks':
					past_due_page_num = page_num;
					if (order_by && sort_order) {
						past_due_order_by   = order_by;
						past_due_sort_order = sort_order;
					}
				break;
				case 'pinned-tasks':
					pinned_page_num = page_num;
					if (order_by && sort_order) {
						pinned_order_by   = order_by;
						pinned_sort_order = sort_order;
					}
				break;
				case 'today-tasks':
					today_page_num = page_num;
					if (order_by && sort_order) {
						past_due_order_by   = order_by;
						past_due_sort_order = sort_order;
					}
				break;
				default:
					// happy linter
			}
		}

		// using the filter, so load only the filtered tasks
		if ($('#filtered-tasks').length > 0) {
			filtered_url = '/Tasks/filtered/page_num:' + filtered_page_num;
			filtered_url += '/order_by:' + filtered_order_by;
			filtered_url += '/sort_order:' + filtered_sort_order;

			Adzuki.Ajax.get(filtered_url)
				.then(function populateFilteredTasks(response) {
					$('#filtered-tasks').html(response);
					$('.task-details').off().on('click', _openTaskDetails);
					$('.complete-task').off().on('click', _completeTask);
					$('.pin-task').off().on('click', _pinTask);

					Adzuki.TaskManager.sortTable($('#filtered-tasks .table-header-sort'), function callback(active_tab, page_num, order_by, sort_order)
					{
						_loadTabs(active_tab, page_num, order_by, sort_order);
					});
				}
			);

			return;
		}

		pinned_url = '/Tasks/pinned/page_num:' + pinned_page_num;
		pinned_url += '/order_by:' + pinned_order_by;
		pinned_url += '/sort_order:' + pinned_sort_order;

		Adzuki.Ajax.get(pinned_url)
			.then(function populatePinnedTasks(response) {
				$('#pinned-tasks').html(response);
				$('.task-details').off().on('click', _openTaskDetails);
				$('.complete-task').off().on('click', _completeTask);
				$('.pin-task').off().on('click', _pinTask);

				Adzuki.TaskManager.sortTable($('#pinned-tasks .table-header-sort'), function callback(active_tab, page_num, order_by, sort_order)
				{
					_loadTabs(active_tab, page_num, order_by, sort_order);
				});
			}
		);

		past_due_url = '/Tasks/pastDue/page_num:' + past_due_page_num;
		past_due_url += '/order_by:' + past_due_order_by;
		past_due_url += '/sort_order:' + past_due_sort_order;

		Adzuki.Ajax.get(past_due_url)
			.then(function populatePastDueTasks(response) {
				$('#past-due-tasks').html(response);
				$('.task-details').off().on('click', _openTaskDetails);
				$('.complete-task').off().on('click', _completeTask);
				$('.pin-task').off().on('click', _pinTask);

				Adzuki.TaskManager.sortTable($('#past-due-tasks .table-header-sort'), function callback(active_tab, page_num, order_by, sort_order)
				{
					_loadTabs(active_tab, page_num, order_by, sort_order);
				});
			}
		);

		today_url = '/Tasks/dueToday/page_num:' + today_page_num;
		today_url += '/order_by:' + today_order_by;
		today_url += '/sort_order:' + today_sort_order;

		Adzuki.Ajax.get(today_url)
			.then(function populateTodayTasks(response) {
				$('#today-tasks').html(response);
				$('.task-details').off().on('click', _openTaskDetails);
				$('.complete-task').off().on('click', _completeTask);
				$('.pin-task').off().on('click', _pinTask);

				Adzuki.TaskManager.sortTable($('#today-tasks .table-header-sort'), function callback(active_tab, page_num, order_by, sort_order)
				{
					_loadTabs(active_tab, page_num, order_by, sort_order);
				});
			}
		);

		upcoming_url = '/Tasks/upcoming/page_num:' + upcoming_page_num;
		upcoming_url += '/order_by:' + upcoming_order_by;
		upcoming_url += '/sort_order:' + upcoming_sort_order;

		Adzuki.Ajax.get(upcoming_url)
			.then(function populateUpcomingTasks(response) {
				$('#upcoming-tasks').html(response);
				$('.task-details').off().on('click', _openTaskDetails);
				$('.complete-task').off().on('click', _completeTask);
				$('.pin-task').off().on('click', _pinTask);

				Adzuki.TaskManager.sortTable($('#upcoming-tasks .table-header-sort'), function callback(active_tab, page_num, order_by, sort_order)
				{
					_loadTabs(active_tab, page_num, order_by, sort_order);
				});
			}
		);

		completed_url = '/Tasks/completed/page_num:' + completed_page_num;
		completed_url += '/order_by:' + completed_order_by;
		completed_url += '/sort_order:' + completed_sort_order;

		Adzuki.Ajax.get(completed_url)
			.then(function populateCompletedTasks(response) {
				$('#completed-tasks').html(response);
				$('.task-details').off().on('click', _openTaskDetails);
				$('.complete-task').off().on('click', _completeTask);
				$('.pin-task').off().on('click', _pinTask);

				Adzuki.TaskManager.sortTable($('#completed-tasks .table-header-sort'), function callback(active_tab, page_num, order_by, sort_order)
				{
					_loadTabs(active_tab, page_num, order_by, sort_order);
				});
			}
		);
	}

	function _openTaskDetails(e)
	{
		var $anchor_elem = $(this);

		e.preventDefault();

		Adzuki.TaskManager.openTaskDetails($anchor_elem);
	}

	function _pinTask(e)
	{
		var $pin_elem = $(this);

		e.preventDefault();

		Adzuki.TaskManager.pinTask($pin_elem, function pinTaskCb(active_tab, page_num, order_by, sort_order) {
			_updateTabNumbers();
			_loadTabs(active_tab, page_num, order_by, sort_order);
		});
	}

	function _removeFilterCriteria($elem)
	{
		var filter_key = $elem.data('filter-key'),
			url        = Adzuki.base_uri + '/Tasks/clearFilter/' + filter_key;

		window.location.href = url;
	}

	function _updateTabNumbers()
	{
		var filter_count_only = 0;

		// using the filter, only count filtered tasks
		if ($('#filtered-tasks').length > 0) {
			filter_count_only = 1;
		}

		Adzuki.Ajax.get('/Tasks/getTasksCounts/' + filter_count_only)
			.then(function getTasksCounts(response) {
				if (filter_count_only === 1) {
					$('#filtered-tasks-tab .badge').text(response.filter_count);
					return;
				}

				// update badge numbers
				$('#pinned-tasks-tab .badge').text(response.pinned_count);
				$('#past-due-tasks-tab .badge').text(response.due_count);
				$('#today-tasks-tab .badge').text(response.today_count);
				$('#upcoming-tasks-tab .badge').text(response.upcoming_count);
				$('#completed-tasks-tab .badge').text(response.completed_count);
			}
		);
	}
}(jQuery, window.Adzuki || {}));
